
import { Base } from '../base-component';
import './add-on-insights.component.scss';

export class AddOnInsights extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}
}


// WEBPACK FOOTER //
// ./components/add-on-insights/add-on-insights.component.ts